module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_vm._v("CHAPTER I")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer Gantry was drunk. He was eloquently drunk, lovingly and pugnaciously drunk. He leaned against the bar of the Old Home Sample Room, the most gilded and urbane saloon in Cato, Missouri, and requested the bartender join him in “The Good Old Summer Time,” the waltz of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Blowing on a glass, polishing it and glancing at Elmer through its flashing rotundity, the bartender remarked that he wasn’t much of a hand at this here singing business. But he smiled. No bartender could have done other than smile on Elmer, so inspired and full of gallantry and hell-raising was he, and so dominating was his beefy grin.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right, old socks,” agreed Elmer. “Me and my room-mate’ll show you some singing as is singing! Meet roommate. Jim Lefferts. Bes’ roommate in world. Wouldn’t live with him if wasn’t! Bes’ quarterback in Milwest. Meet roommate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The bartender again met Mr. Lefferts, with protestations of distinguished pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer and Jim Lefferts retired to a table to nourish the long, rich, chocolate strains suitable to drunken melody. Actually, they sang very well. Jim had a resolute tenor, and as to Elmer Gantry, even more than his bulk, his thick black hair, his venturesome black eyes, you remembered that arousing barytone. He was born to be a senator. He never said anything important, and he always said it sonorously. He could make “Good morning” seem profound as Kant, welcoming as a brass band, and uplifting as a cathedral organ. It was a ‘cello, his voice, and in the enchantment of it you did not hear his slang, his boasting, his smut, and the dreadful violence which (at this period) he performed on singulars and plurals.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Luxuriously as a wayfarer drinking cool beer they caressed the phrases in linked sweetness long drawn out:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Strolling through the shaaaaady lanes, with your baby-mine,")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You hold her hand and she holds yours, and that’s a very good sign")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That she’s your tootsey-wootsey in the good old summer time.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer wept a little, and blubbered, “Lez go out and start a scrap. You’re a lil squirt, Jim. You get somebody to pick on you, and I’ll come along and knock his block off. I’ll show ‘em!” His voice flared up. He was furious at the wrong about to be suffered. He arched his paws with longing to grasp the nonexistent scoundrel. “By God, I’ll knock the tar out of um! Nobody can touch my roommate. Know who I am? Elmer Gantry! Thash me! I’ll show um!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The bartender was shuffling toward them, amiably ready for homicide.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Shut up, Hell-cat. What you need is ‘nother drink. I’ll get ‘nother drink,” soothed Jim, and Elmer slid into tears, weeping over the ancient tragic sorrows of one whom he remembered as Jim Lefferts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Instantly, by some tricky sort of magic, there were two glasses in front of him. He tasted one, and murmured foolishly, “‘Scuse me.” It was the chase, the water. But they couldn’t fool him! The whisky would certainly be in that other lil sawed-off glass. And it was. He was right, as always. With a smirk of self-admiration he sucked in the raw Bourbon. It tickled his throat and made him feel powerful, and at peace with every one save that fellow—he could not recall who, but it was some one whom he would shortly chastise, and after that float into an Elysium of benevolence.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The barroom was deliriously calming. The sour invigorating stench of beer made him feel healthy. The bar was one long shimmer of beauty—glowing mahogany, exquisite marble rail, dazzling glasses, curiously shaped bottles of unknown liqueurs, piled with a craftiness which made him very happy. The light was dim, completely soothing, coming through fantastic windows such as are found only in churches, saloons, jewelry shops, and other retreats from reality. On the brown plaster walls were sleek naked girls.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He turned from them. He was empty now of desire for women.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That damn’ Juanita. Jus’ wants to get all she can out of you. That’s all,” he grumbled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But there was an interesting affair beside him. A piece of newspaper sprang up, apparently by itself, and slid along the floor. That was a very funny incident, and he laughed greatly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was conscious of a voice which he had been hearing for centuries, echoing from a distant point of light and flashing through ever-widening corridors of a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We’ll get kicked out of here, Hell-cat. Come on!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He floated up. It was exquisite. His legs moved by themselves, without effort. They did a comic thing once—they got twisted and the right leg leaped in front of the left when, so far as he could make out, it should have been behind. He laughed, and rested against some one’s arm, an arm with no body attached to it, which had come out of the Ewigkeit to assist him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then unknown invisible blocks, miles of them, his head clearing, and he made grave announcement to a Jim Lefferts who suddenly seemed to be with him:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I gotta lick that fellow.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All right, all right. You might as well go find a nice little fight and get it out of your system!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was astonished; he was grieved. His mouth hung open and he drooled with sorrow. But still, he was to be allowed one charming fight, and he revived as he staggered industriously in search of it.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Oh, he exulted, it was a great party. For the first time in weeks he was relieved from the boredom of Terwillinger College.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer Gantry, best known to classmates as Hell-cat, had, this autumn of 1902, been football captain and led the best team Terwillinger College had known in ten years. They had won the championship of the East-middle Kansas Conference, which consisted of ten denominational colleges, all of them with buildings and presidents and chapel services and yells and colors and a standard of scholarship equal to the best high-schools. But since the last night of the football season, with the glorious bonfire in which the young gentlemen had burned up nine tar barrels, the sign of the Jew tailor, and the president’s tabby-cat, Elmer had been tortured by boredom.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He regarded basket-ball and gymnasium antics as light-minded for a football gladiator. When he had come to college, he had supposed he would pick up learnings of cash-value to a lawyer or doctor or insurance man—he had not known which he would become, and in his senior year, aged twenty-two this November, he still was doubtful. But this belief he found fallacious. What good would it be in the courtroom, or at the operating table, to understand trigonometry, or to know (as last spring, up to the examination on European History, he remembered having known) the date of Charlemagne? How much cash would it bring in to quote all that stuff—what the dickens was it now?—all that rot about “The world is too much around us, early and soon” from that old fool Wordsworth?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Punk, that’s what it was. Better be out in business. But still, if his mother claimed she was doing so well with her millinery business and wanted him to be a college graduate, he’d stick by it. Lot easier than pitching hay or carrying two-by-fours anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Despite his invaluable voice, Elmer had not gone out for debating because of the irritating library-grinding, nor had he taken to prayer and moral eloquence in the Y.M.C.A., for with all the force of his simple and valiant nature he detested piety and admired drunkenness and profanity.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Once or twice in the class in Public Speaking, when he had repeated the splendors of other great thinkers, Dan’l Webster and Henry Ward Beecher and Chauncey M. Depew, he had known the intoxication of holding an audience with his voice as with his closed hand, holding it, shaking it, lifting it. The debating set urged him to join them, but they were rabbit-faced and spectacled young men, and he viewed as obscene the notion of digging statistics about immigration and the products of San Domingo out of dusty spotted books in the dusty spotted library.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He kept from flunking only because Jim Lefferts drove him to his books.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim was less bored by college. He had a relish for the flavor of scholarship. He liked to know things about people dead these thousand years, and he liked doing canned miracles in chemistry. Elmer was astounded that so capable a drinker, a man so deft at “handing a girl a swell spiel and getting her going” should find entertainment in Roman chariots and the unenterprising amours of sweet-peas. But himself—no. Not on your life. He’d get out and finish law school and never open another book—kid the juries along and hire some old coot to do the briefs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To keep him from absolutely breaking under the burden of hearing the professors squeak, he did have the joy of loafing with Jim, illegally smoking the while; he did have researches into the lovability of co-eds and the baker’s daughter; he did revere becoming drunk and world-striding. But he could not afford liquor very often and the co-eds were mostly ugly and earnest.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was lamentable to see this broad young man, who would have been so happy in the prize-ring, the fish-market, or the stock exchange, poking through the cobwebbed corridors of Terwillinger.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Terwillinger College, founded and preserved by the more zealous Baptists, is on the outskirts of Gritzmacher Springs, Kansas. (The springs have dried up and the Gritzmachers have gone to Los Angeles, to sell bungalows and delicatessen.) It huddles on the prairie, which is storm-racked in winter, frying and dusty in summer, lovely only in the grass-rustling spring or drowsy autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You would not be likely to mistake Terwillinger College for an Old Folks’ Home, because on the campus is a large rock painted with class numerals.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Most of the faculty are ex-ministers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is a men’s dormitory, but Elmer Gantry and Jim Lefferts lived together in the town, in a mansion once the pride of the Gritzmachers themselves: a square brick bulk with a white cupola. Their room was unchanged from the days of the original August Gritzmacher; a room heavy with a vast bed of carved black walnut, thick and perpetually dusty brocade curtains, and black walnut chairs hung with scarves that dangled gilt balls. The windows were hard to open. There was about the place the anxious propriety and all the dead hopes of a second-hand furniture shop.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In this museum, Jim had a surprising and vigorous youthfulness. There was a hint of future flabbiness in Elmer’s bulk, but there would never be anything flabby about Jim Lefferts. He was slim, six inches shorter than Elmer, but hard as ivory and as sleek. Though he came from a prairie village, Jim had fastidiousness, a natural elegance. All the items of his wardrobe, the “ordinary suit,” distinctly glossy at the elbows, and the dark-brown “best suit,” were ready-made, with faltering buttons, and seams that betrayed rough ends of thread, but on him they were graceful. You felt that he would belong to any set in the world which he sufficiently admired. There was a romantic flare to his upturned overcoat collar; the darned bottoms of his trousers did not suggest poverty but a careless and amused ease; and his thoroughly commonplace ties hinted of clubs and regiments.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His thin face was resolute. You saw only its youthful freshness first, then behind the brightness a taut determination, and his brown eyes were amiably scornful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim Lefferts was Elmer’s only friend; the only authentic friend he had ever had.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Though Elmer was the athletic idol of the college, though his occult passion, his heavy good looks, caused the college girls to breathe quickly, though his manly laughter was as fetching as his resonant speech, Elmer was never really liked. He was supposed to be the most popular man in college; every one believed that every one else adored him; and none of them wanted to be with him. They were all a bit afraid, a bit uncomfortable, and more than a bit resentful.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was not merely that he was a shouter, a pounder on backs, an overwhelming force, so that there was never any refuge of intimacy with him. It was because he was always demanding. Except with his widow mother, whom he vaguely worshiped, and with Jim Lefferts, Elmer assumed that he was the center of the universe and that the rest of the system was valuable only as it afforded him help and pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He wanted everything.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His first year, as the only Freshman who was playing on the college football team, as a large and smiling man who was expected to become a favorite, he was elected president. In that office, he was not much beloved. At class-meetings he cut speakers short, gave the floor only to pretty girls and lads who toadied to him, and roared in the midst of the weightiest debates, “Aw, come on, cut out this chewing the rag and let’s get down to business!” He collected the class-fund by demanding subscriptions as arbitrarily as a Catholic priest assessing his parishoners for a new church.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’ll never hold any office again, not if I can help it!” muttered one Eddie Fislinger, who, though he was a meager and rusty-haired youth with protruding teeth and an uneasy titter, had attained power in the class by always being present at everything, and by the piety and impressive intimacy of his prayers in the Y.M.C.A.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There was a custom that the manager of the Athletic Association should not be a member of any team. Elmer forced himself into the managership in Junior year by threatening not to play football if he were not elected. He appointed Jim Lefferts chairman of the ticket committee, and between them, by only the very slightest doctoring of the books, they turned forty dollars to the best of all possible uses.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At the beginning of Senior year, Elmer announced that he desired to be president again. To elect any one as class-president twice was taboo. The ardent Eddie Fislinger, now president of the Y.M.C.A. and ready to bring his rare talents to the Baptist ministry, asserted after an enjoyable private prayer-meeting in his room that he was going to face Elmer and forbid him to run.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Gwan! You don’t dare!” observed a Judas who three minutes before had been wrestling with God under Eddie’s coaching.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t, eh? Watch me! Why, everybody hates him, the darn’ hog!” squeaked Eddie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By scurrying behind trees he managed to come face to face with Elmer on the campus. He halted, and spoke of football, quantitative chemistry, and the Arkansas spinster who taught German.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer grunted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Desperately, his voice shrill with desire to change the world, Eddie stammered:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Say—say, Hell-cat, you hadn’t ought to run for president again. Nobody’s ever president twice!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Somebody’s going to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ah, gee, Elmer, don’t run for it. Ah, come on. Course all the fellows are crazy about you but—Nobody’s ever been president twice. They’ll vote against you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let me catch ‘em at it!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How can you stop it? Honest, Elm—Hell-cat—I’m just speaking for your own good. The voting’s secret. You can’t tell—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Huh! The nominations ain’t secret! Now you go roll your hoop, Fissy, and let all the yellow coyotes know that anybody that nominates anybody except Uncle Hell-cat will catch it right where the chicken caught the ax. See? And if they tell me they didn’t know about this, you’ll get merry Hail Columbia for not telling ‘em. Get me? If there’s anything but an unanimous vote, you won’t do any praying the rest of this year!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie remembered how Elmer and Jim had shown a Freshman his place in society by removing all his clothes and leaving him five miles in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was elected president of the senior class—unanimously.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He did not know that he was unpopular. He reasoned that men who seemed chilly to him were envious and afraid, and that gave him a feeling of greatness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Thus it happened that he had no friend save Jim Lefferts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Only Jim had enough will to bully him into obedient admiration. Elmer swallowed ideas whole; he was a maelstrom of prejudices; but Jim accurately examined every notion that came to him. Jim was selfish enough, but it was with the selfishness of a man who thinks and who is coldly unafraid of any destination to which his thoughts may lead him. The little man treated Elmer like a large damp dog, and Elmer licked his shoes and followed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He also knew that Jim, as quarter, was far more the soul of the team than himself as tackle and captain.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A huge young man, Elmer Gantry; six foot one, thick, broad, big handed; a large face, handsome as a Great Dane is handsome, and a swirl of black hair, worn rather long. His eyes were friendly, his smile was friendly—oh, he was always friendly enough; he was merely astonished when he found that you did not understand his importance and did not want to hand over anything he might desire. He was a barytone solo turned into portly flesh; he was a gladiator laughing at the comic distortion of his wounded opponent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He could not understand men who shrank from blood, who liked poetry or roses, who did not casually endeavor to seduce every possibly seducible girl. In sonorous arguments with Jim he asserted that “these fellows that study all the time are just letting on like they’re so doggone high and mighty, to show off to those doggone profs that haven’t got anything but lemonade in their veins.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Chief adornment of their room was the escritoire of the first Gritzmacher, which held their library. Elmer owned two volumes of Conan Doyle, one of E. P. Roe, and a priceless copy of “Only a Boy.” Jim had invested in an encyclopedia which explained any known subject in ten lines, in a “Pickwick Papers,” and from some unknown source he had obtained a complete Swinburne, into which he was never known to have looked.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But his pride was in the possession of Ingersoll’s “Some Mistakes of Moses,” and Paine’s “The Age of Reason.” For Jim Lefferts was the college freethinker, the only man in Terwillinger who doubted that Lot’s wife had been changed into salt for once looking back at the town where, among the young married set, she had had so good a time; who doubted that Methuselah lived to nine hundred and sixty-nine.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They whispered of Jim all through the pious dens of Terwillinger. Elmer himself was frightened, for after giving minutes and minutes to theological profundities Elmer had concluded that “there must be something to all this religious guff if all these wise old birds believe it, and some time a fellow had ought to settle down and cut out the hell-raising.” Probably Jim would have been kicked out of college by the ministerial professors if he had not had so reverent a way of asking questions when they wrestled with his infidelity that they let go of him in nervous confusion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even the President, the Rev. Dr. Willoughby Quarles, formerly pastor of the Rock of Ages Baptist Church of Moline, Ill., than whom no man had written more about the necessity of baptism by immersion, in fact in every way a thoroughly than-whom figure—even when Dr. Quarles tackled Jim and demanded, “Are you getting the best out of our instruction, young man? Do you believe with us not only in the plenary inspiration of the Bible but also in its verbal inspiration, and that it is the only divine rule of faith and practise?” then Jim looked docile and said mildly:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, yes, Doctor. There’s just one or two little things that have been worrying me, Doctor. I’ve taken them to the Lord in prayer, but he doesn’t seem to help me much. I’m sure you can. Now why did Joshua need to have the sun stand still? Of course it happened—it says so right in Scripture. But why did he need to, when the Lord always helped those Jews, anyway, and when Joshua could knock down big walls just by having his people yell and blow trumpets? And if devils cause a lot of the diseases, and they had to cast ‘em out, why is it that good Baptist doctors today don’t go on diagnosing devil-possession instead of T. B. and things like that? Do people have devils?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Young man, I will give you an infallible rule. Never question the ways of the Lord!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But why don’t the doctors talk about having devils now?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have no time for vain arguments that lead nowhere! If you would think a little less of your wonderful powers of reasoning, if you’d go humbly to God in prayer and give him a chance, you’d understand the true spiritual significances of all these things.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But how about where Cain got his wife—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Most respectfully Jim said it, but Dr. Quarles (he had a chin-whisker and a boiled shirt) turned from him and snapped, “I have no further time to give you, young man! I’ve told you what to do. Good morning!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That evening Mrs. Quarles breathed, “Oh, Willoughby, did you ‘tend to that awful senior—that Lefferts—that’s trying to spread doubt? Did you fire him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” blossomed President Quarles. “Certainly not. There was no need. I showed him how to look for spiritual guidance and—Did that freshman come and mow the lawn? The idea of him wanting fifteen cents an hour!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim was hair-hung and breeze-shaken over the abyss of hell, and apparently enjoying it very much indeed, while his wickedness fascinated Elmer Gantry and terrified him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("That November day of 1902, November of their Senior year, was greasy of sky, and slush blotted the wooden sidewalks of Gritzmacher Springs. There was nothing to do in town, and their room was dizzying with the stench of the stove, first lighted now since spring.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim was studying German, tilted back in an elegant position of ease, with his legs cocked up on the desk tablet of the escritoire. Elmer lay across the bed, ascertaining whether the blood would run to his head if he lowered it over the side. It did, always.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, God, let’s get out and do something!” he groaned.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nothing to do, Useless,” said Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Let’s go over to Cato and see the girls and get drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As Kansas was dry, by state prohibition, the nearest haven was at Cato, Missouri, seventeen miles away.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim scratched his head with a corner of his book and approved:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, that’s a worthy idea. Got any money?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“On the twenty-eighth? Where the hell would I get any money before the first?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hell-cat, you’ve got one of the deepest intellects I know. You’ll be a knock-out at the law. Aside from neither of us having any money, and me with a Dutch quiz tomorrow, it’s a great project.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, well—” sighed ponderous Elmer, feebly as a sick kitten, and lay revolving the tremendous inquiry.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was Jim who saved them from the lard-like weariness into which they were slipping. He had gone back to his book, but he placed it, precisely and evenly, on the desk, and rose.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I would like to see Nellie,” he sighed. “Oh, man, I could give her a good time! Little Devil! Damn these co-eds here. The few that’ll let you love ‘em up, they hang around trying to catch you on the campus and make you propose to ‘em.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, gee! And I got to see Juanita,” groaned Elmer. “Hey, cut out talking about ‘em will you! I’ve got a palpitating heart right now, just thinking about Juanny!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hell-cat! I’ve got it. Go and borrow ten off this new instructor in chemistry and physics. I’ve got a dollar sixty-four left, and that’ll make it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But I don’t know him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure, you poor fish. That’s why I suggested him! Do the check-failed-to-come. I’ll get another hour of this Dutch while you’re stealing the ten from him—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now,” lugubriously, “you oughtn’t to talk like that!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If you’re as good a thief as I think you are, we’ll catch the five-sixteen to Cato.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They were on the five-sixteen for Cato.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The train consisted of a day coach, a combined smoker and baggage car, and a rusty old engine and tender. The train swayed so on the rough tracks as it bumped through the dropping light that Elmer and Jim were thrown against each other and gripped the arm of their seat. The car staggered like a freighter in a gale. And tall raw farmers, perpetually shuffling forward for a drink at the water-cooler, stumbled against them or seized Jim’s shoulder to steady themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("To every surface of the old smoking-car, to streaked windows and rusty ironwork and mud-smeared cocoanut matting, clung a sickening bitterness of cheap tobacco fumes, and whenever they touched the red plush of the seat, dust whisked up and the prints of their hands remained on the plush. The car was jammed. Passengers came to sit on the arm of their seat to shout at friends across the aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Elmer and Jim were unconscious of filth and smell and crowding. They sat silent, nervously intent, panting a little, their lips open, their eyes veiled, as they thought of Juanita and Nellie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The two girls, Juanita Klauzel and Nellie Benton, were by no means professional daughters of joy. Juanita was cashier of the Cato Lunch—Quick Eats; Nellie was assistant to a dressmaker. They were good girls but excitable, and they found a little extra money useful for red slippers and nut-center chocolates.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Juanita—what a lil darling—she understands a fellow’s troubles,” said Elmer, as they balanced down the slushy steps at the grimy stone station of Cato.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Elmer, as a Freshman just arrived from the pool-halls and frame high school of Paris, Kansas, had begun to learn the decorum of amour, he had been a boisterous lout who looked shamefaced in the presence of gay ladies, who blundered against tables, who shouted and desired to let the world know how valiantly vicious he was being. He was still rather noisy and proud of wickedness when he was in a state of liquor, but in three and a quarter years of college he had learned how to approach girls. He was confident, he was easy, he was almost quiet; he could look them in the eye with fondness and amusement.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Juanita and Nellie lived with Nellie’s widow aunt—she was a moral lady, but she knew how to keep out of the way—in three rooms over a corner grocery. They had just returned from work when Elmer and Jim stamped up the rickety outside wooden steps. Juanita was lounging on a divan which even a noble Oriental red and yellow cover (displaying a bearded Wazir, three dancing ladies in chiffon trousers, a narghile, and a mosque slightly larger than the narghile) could never cause to look like anything except a disguised bed. She was curled up, pinching her ankle with one tired and nervous hand, and reading a stimulating chapter of Laura Jean Libbey. Her shirt-waist was open at the throat, and down her slim stocking was a grievous run. She was so un-Juanita-like—an ash-blonde, pale and lovely, with an ill-restrained passion in her blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nellie, a buxom jolly child, dark as a Jewess, was wearing a frowsy dressing-gown. She was making coffee and narrating her grievances against her employer, the pious dressmaker, while Juanita paid no attention whatever. The young men crept into the room without knocking. “You devils—sneaking in like this, and us not dressed!” yelped Nellie.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim sidled up to her, dragged her plump hand away from the handle of the granite-ware coffee-pot, and giggled, “But aren’t you glad to see us?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know whether I am or not! Now you quit! You behave, will you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rarely did Elmer seem more deft than Jim Lefferts. But now he was feeling his command over women—certain sorts of women. Silent, yearning at Juanita, commanding her with hot eyes, he sank on the temporarily Oriental couch, touched her pale hand with his broad finger-tips, and murmured, “Why you poor kid, you look so tired!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I am and—You hadn’t ought to come here this afternoon. Nell’s aunt threw a conniption fit the last time you were here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hurray for aunty! But you’re glad to see me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She would not answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bold eyes on hers that turned uneasily away, looked back, and sought the safety of the blank wall.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She would not answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Juanita! And I’ve longed for you something fierce, ever since I saw you!” His fingers touched her throat, but softly. “Aren’t you a little glad?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As she turned her head, for a second she looked at him with embarrassed confession. She sharply whispered, “No—don’t!” as he caught her hand, but she moved nearer to him, leaned against his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re so big and strong,” she sighed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“But, golly, you don’t know how I need you! The president, old Quarles—quarrels is right, by golly, ha, ha, ha!—’member I was telling you about him?—he’s laying for me because he thinks it was me and Jim that let the bats loose in chapel. And I get so sick of that gosh-awful Weekly Bible Study—all about these holy old gazebos. And then I think about you, and gosh, if you were just sitting on the other side of the stove from me in my room there, with your cute lil red slippers cocked up on the nickel rail—gee, how happy I’d be! You don’t think I’m just a bonehead, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jim and Nellie were at the stage now of nudging each other and bawling, “Hey, quit, will yuh!” as they stood over the coffee.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Say, you girls change your shirts and come on out and we’ll blow you to dinner, and maybe we’ll dance a little,” proclaimed Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We can’t,” said Nellie. “Aunty’s sore as a pup because we was up late at a dance night before last. We got to stay home, and you boys got to beat it before she comes in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Aw, come on!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, we can’t!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yuh, fat chance you girls staying home and knitting! You got some fellows coming in and you want to get rid of us, that’s what’s the trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It is not, Mr. James Lefferts, and it wouldn’t be any of your business if it was!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("While Jim and Nellie squabbled, Elmer slipped his hand about Juanita’s shoulder, slowly pressed her against him. He believed with terrible conviction that she was beautiful, that she was glorious, that she was life. There was heaven in the softness of her curving shoulder, and her pale flesh was living silk.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come on in the other room,” he pleaded.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh—no—not now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He gripped her arm.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well—don’t come in for a minute,” she fluttered. Aloud, to the others, “I’m going to do my hair. Looks just ter-ble!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She slipped into the room beyond. A certain mature self-reliance dropped from Elmer’s face, and he was like a round-faced big baby, somewhat frightened. With efforts to appear careless, he fumbled about the room and dusted a pink and gilt vase with his large crumpled handkerchief. He was near the inner door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He peeped at Jim and Nellie. They were holding hands, while the coffee-pot was cheerfully boiling over. Elmer’s heart thumped. He slipped through the door and closed it, whimpering, as in terror:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh—Juanita—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They were gone, Elmer and Jim, before the return of Nellie’s aunt. As they were not entertaining the girls, they dined on pork chops, coffee, and apple pie at the Maginnis Lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It has already been narrated that afterward, in the Old Home Sample Room, Elmer became philosophical and misogynistic as he reflected that Juanita was unworthy of his generous attention; it has been admitted that he became drunk and pugnacious.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As he wavered through the sidewalk slush, on Jim’s arm, as his head cleared, his rage increased against the bully who was about to be encouraged to insult his goo’ frien’ and roommate. His shoulders straightened, his fists clenched, and he began to look for the scoundrel among the evening crowd of mechanics and coal-miners.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They came to the chief corner of the town. A little way down the street, beside the red brick wall of the Congress Hotel, some one was talking from the elevation of a box, surrounded by a jeering gang.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What they picking on that fella that’s talking for? They better let him alone!” rejoiced Elmer, throwing off Jim’s restraining hand, dashing down the side street and into the crowd. He was in that most blissful condition to which a powerful young man can attain—unrighteous violence in a righteous cause. He pushed through the audience, jabbed his elbow into the belly of a small weak man, and guffawed at the cluck of distress. Then he came to a halt, unhappy and doubting.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The heckled speaker was his chief detestation, Eddie Fislinger, president of the Terwillinger College Y.M.C.A., that rusty-haired gopher who had obscenely opposed his election as president.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("With two other seniors who were also in training for the Baptist ministry, Eddie had come over to Cato to save a few souls. At least, if they saved no souls (and they never had saved any, in seventeen street meetings) they would have handy training for their future jobs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie was a rasping and insistent speaker who got results by hanging to a subject and worrying it, but he had no great boldness, and now he was obviously afraid of his chief heckler, a large, blond, pompadoured young baker, who bulked in front of Eddie’s rostrum and asked questions. While Elmer stood listening, the baker demanded:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What makes you think you know all about religion?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t pretend to know all about religion, my friend, but I do know what a powerful influence it is for clean and noble living, and if you’ll only be fair now, my friend, and give me a chance to tell these other gentlemen what my experience of answers to prayer has been—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yuh, swell lot of experience you’ve had, by your looks!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“See here, there are others who may want to hear—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Though Elmer detested Eddie’s sappiness, though he might have liked to share drinks with the lively young baker-heckler, there was no really good unctuous violence to be had except by turning champion of religion. The packed crowd excited him, and the pressure of rough bodies, the smell of wet overcoats, the rumble of mob voices. It was like a football line-up.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Here, you!” he roared at the baker. “Let the fellow speak! Give him a chance. Whyn’t you pick on somebody your own size, you big stiff!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("At his elbow, Jim Lefferts begged, “Let’s get out of this, Hell-cat. Good Lord! You ain’t going to help a gospel-peddler!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer pushed him away and thrust his chest out toward the baker, who was cackling, “Heh! I suppose you’re a Christer, too!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I would be, if I was worthy!” Elmer fully believed it, for that delightful moment. “These boys are classmates of mine, and they’re going to have a chance to speak!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie Fislinger bleated to his mates, “Oh, fellows, Elm Gantry! Saved!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Even this alarming interpretation of his motives could not keep Elmer now from the holy zeal of fighting. He thrust aside the one aged man who stood between him and the baker—bashing in the aged one’s derby and making him telescope like a turtle’s neck—and stood with his fist working like a connecting-rod by his side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If you’re looking for trouble—” the baker suggested, clumsily wobbling his huge bleached fists.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not me,” observed Elmer and struck, once, very judiciously, just at the point of the jaw.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The baker shook like a skyscraper in an earthquake and caved to the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One of the baker’s pals roared, “Come on, we’ll kill them guys and—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer caught him on the left ear. It was a very cold ear, and the pal staggered, extremely sick. Elmer looked pleased. But he did not feel pleased. He was almost sober, and he realized that half a dozen rejoicing young workmen were about to rush him. Though he had an excellent opinion of himself, he had seen too much football, as played by denominational colleges with the Christian accompaniments of kneeing and gouging, to imagine that he could beat half a dozen workmen at once.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It is doubtful whether he would ever have been led to further association with the Lord and Eddie Fislinger had not Providence intervened in its characteristically mysterious way. The foremost of the attackers was just reaching for Elmer when the mob shouted, “Look out! The cops!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The police force of Cato, all three of them, were wedging into the crowd. They were lanky, mustached men with cold eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s all this row about?” demanded the chief.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He was looking at Elmer, who was three inches taller than any one else in the assembly.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Some of these fellows tried to stop a peaceable religious assembly—why, they tried to rough-house the Reverend here—and I was protecting him,” Elmer said.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right, Chief. Reg’lar outrage,” complained Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s true, Chief,” whistled Eddie Fislinger from his box.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well, you fellows cut it out now. What the hell! Ought to be ashamed yourselves, bullyragging a Reverend! Go ahead, Reverend!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The baker had come to, and had been lifted to his feet. His expression indicated that he had been wronged and that he wanted to do something about it, if he could only find out what had happened. His eyes were wild, his hair was a muddy chaos, and his flat floury cheek was cut. He was too dizzy to realize that the chief of police was before him, and his fumbling mind stuck to the belief that he was destroying all religion.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yah, so you’re one of them wishy-washy preachers, too!” he screamed at Elmer—just as one of the lanky policemen reached out an arm of incredible length and nipped him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The attention of the crowd warmed Elmer, and he expanded in it, rubbed his mental hands in its blaze.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Maybe I ain’t a preacher! Maybe I’m not even a good Christian!” he cried. “Maybe I’ve done a whole lot of things I hadn’t ought to of done. But let me tell you, I respect religion—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, amen, praise the Lord, brother,” from Eddie Fislinger.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“—and I don’t propose to let anybody interfere with it. What else have we got except religion to give us hope—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Praise the Lord, oh, bless his name!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“—of ever leading decent lives, tell me that, will you, just tell me that!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer was addressing the chief of police, who admitted:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yuh, I guess that’s right. Well now, we’ll let the meeting go on, and if any more of you fellows interrupt—” This completed the chief’s present ideas on religion and mob-violence. He looked sternly at everybody within reach, and stalked through the crowd, to return to the police station and resume his game of seven-up.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie was soaring into enchanted eloquence:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, my brethren, now you see the power of the spirit of Christ to stir up all that is noblest and best in us! You have heard the testimony of our brother here, Brother Gantry, to the one and only way to righteousness! When you get home I want each and every one of you to dig out the Old Book and turn to the Song of Solomon, where it tells about the love of the Savior for the Church—turn to the Song of Solomon, the fourth chapter and the tenth verse, where it says—where Christ is talking about the church, and he says—Song of Solomon, the fourth chapter, and the tenth verse—’How fair is thy love, my sister, my spouse! how much better is thy love than wine!’")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, the unspeakable joy of finding the joys of salvation! You have heard our brother’s testimony. We know of him as a man of power, as a brother to all them that are oppressed, and now that he has had his eyes opened and his ears unstopped, and he sees the need of confession and of humble surrender before the throne—Oh, this is a historic moment in the life of Hell-c—of Elmer Gantry! Oh, Brother, be not afraid! Come! Step up here beside me, and give testimony—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“God! We better get outa here quick!” panted Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Gee, yes!” Elmer groaned and they edged back through the crowd, while Eddie Fislinger’s piping pursued them like icy and penetrating rain:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t be afraid to acknowledge the leading of Jesus! Are you boys going to show yourselves too cowardly to risk the sneers of the ungodly?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They were safely out of the crowd, walking with severe countenances and great rapidity back to the Old Home Sample Room.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That was a dirty trick of Eddie’s!” said Jim. “God, it certainly was! Trying to convert me! Right before those muckers! If I ever hear another yip out of Eddie, I’ll knock his block off! Nerve of him, trying to lead me up to any mourners’ bench! Fat chance! I’ll fix him! Come on, show a little speed!” asserted the brother to all them that were oppressed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("By the time for their late evening train, the sound conversation of the bartender and the sound qualities of his Bourbon had caused Elmer and Jim to forget Eddie Fislinger and the horrors of undressing religion in public. They were the more shocked, then, swaying in their seat in the smoker, to see Eddie standing by them, Bible in hand, backed by his two beaming partners in evangelism.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie bared his teeth, smiled all over his watery eyes, and caroled:")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, fellows, you don’t know how wonderful you were tonight! But, oh, boys, now you’ve taken the first step, why do you put it off—why do you hesitate—why do you keep the Savior suffering as he waits for you, longs for you? He needs you boys, with your splendid powers and intellects that we admire so—”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This air,” observed Jim Lefferts, “is getting too thick for me. I seem to smell a peculiar and a fishlike smell.” He slipped out of the seat and marched toward the forward car.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Elmer sought to follow him, but Eddie had flopped into Jim’s place and was blithely squeaking on, while the other two hung over them with tender Y.M.C.A. smiles very discomforting to Elmer’s queasy stomach as the train bumped on.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For all his brave words, Elmer had none of Jim’s resolute contempt for the church. He was afraid of it. It connoted his boyhood … His mother, drained by early widowhood and drudgery, finding her only emotion in hymns and the Bible, and weeping when he failed to study his Sunday School lesson. The church, full thirty dizzy feet up to its curiously carven rafters, and the preachers, so overwhelming in their wallowing voices, so terrifying in their pictures of little boys who stole watermelons or indulged in biological experiments behind barns. The awe-oppressed moment of his second conversion, at the age of eleven, when, weeping with embarrassment and the prospect of losing so much fun, surrounded by solemn and whiskered adult faces, he had signed a pledge binding him to give up, forever, the joys of profanity, alcohol, cards, dancing, and the theater.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("These clouds hung behind and over him, for all his boldness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Eddie Fislinger, the human being, he despised. He considered him a grasshopper, and with satisfaction considered stepping on him. But Eddie Fislinger, the gospeler, fortified with just such a pebble-leather Bible (bookmarks of fringed silk and celluloid smirking from the pages) as his Sunday School teachers had wielded when they assured him that God was always creeping about to catch small boys in their secret thoughts—this armored Eddie was an official, and Elmer listened to him uneasily, never quite certain that he might not yet find himself a dreadful person leading a pure a boresome life in a clean frock coat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“—and remember,” Eddie was wailing, “how terribly dangerous it is to put off the hour of salvation! ‘Watch therefore for you know not what hour your Lord doth come,’ it says. Suppose this train were wrecked! Tonight!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The train ungraciously took that second to lurch on a curve.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You see? Where would you spend Eternity, Hell-cat? Do you think that any sportin’ round is fun enough to burn in hell for?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, cut it out. I know all that stuff. There’s a lot of arguments—You wait’ll I get Jim to tell you what Bob Ingersoll said about hell!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes! Sure! And you remember that on his deathbed Ingersoll called his son to him and repented and begged his son to hurry and be saved and burn all his wicked writings!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well—Thunder—I don’t feel like talking religion tonight. Cut it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But Eddie did feel like talking religion, very much so. He waved his Bible enthusiastically and found ever so many uncomfortable texts. Elmer listened as little as possible but he was too feeble to make threats.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It was a golden relief when the train bumped to a stop at Gritzmacher Springs. The station was a greasy wooden box, the platform was thick with slush, under the kerosene lights. But Jim was awaiting him, a refuge from confusing theological questions, and with a furious “G’night!” to Eddie he staggered off.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why didn’t you make him shut his trap?” demanded Jim.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I did! Whadja take a sneak for? I told him to shut up and he shut up and I snoozed all the way back and—Ow! My head! Don’t walk so fast!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d58a058c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElmerGantry-3.vue
// module id = 66
// module chunks = 0